module.exports = __webpack_public_path__ + "static/media/hallsbergvapen.7adde01b.png";